import React, { useState } from "react";
import { clsx } from "clsx";

interface PasswordInputProps
	extends React.InputHTMLAttributes<HTMLInputElement> {
	label?: string;
	error?: string;
	name: string;
}

export const PasswordInput: React.FC<PasswordInputProps> = ({
	label,
	error,
	name,
	className,
	...props
}) => {
	const [isVisible, setIsVisible] = useState(false);

	// Let users see their password if they want to check what they typed
	const toggleVisibility = () => {
		setIsVisible(!isVisible);
	};

	return (
		<div className="space-y-1">
			{label && (
				<label
					htmlFor={name}
					className="block text-sm font-medium text-foreground">
					{label}
				</label>
			)}

			<div className="relative">
				<input
					id={name}
					name={name}
					type={isVisible ? "text" : "password"}
					className={clsx(
						"w-full px-4 py-3 pr-12 rounded-lg border border-border bg-background text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-ring transition-colors",
						error && "border-destructive focus:ring-destructive focus:border-destructive",
						className
					)}
					{...props}
				/>

				<button
					type="button"
					onClick={toggleVisibility}
					className="absolute right-3 top-1/2 transform -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors">
					{isVisible ? (
						<svg
							width="20"
							height="20"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<path
								d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
								stroke="currentColor"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<circle
								cx="12"
								cy="12"
								r="3"
								stroke="currentColor"
								strokeWidth="2"
							/>
						</svg>
					) : (
						<svg
							width="20"
							height="20"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<path
								d="M14.12 14.12C13.8454 14.4148 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1749 15.0074 10.8016 14.8565C10.4283 14.7056 10.0901 14.4811 9.80689 14.1979C9.52372 13.9147 9.29924 13.5765 9.14833 13.2032C8.99742 12.8299 8.92332 12.4295 8.9304 12.0267C8.93748 11.6239 9.02569 11.2266 9.18964 10.8587C9.35359 10.4907 9.58994 10.1594 9.88477 9.88477M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.68192 3.96914 7.65663 6.06 6.06M9.9 4.24C10.5883 4.0789 11.2931 3.99836 12 4C19 4 23 12 23 12C22.393 13.1356 21.6691 14.2048 20.84 15.19M14.12 14.12L9.88 9.88M14.12 14.12L20 20M9.88 9.88L4 4"
								stroke="currentColor"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					)}
				</button>
			</div>

			{error && <p className="text-xs text-destructive mt-1">{error}</p>}
		</div>
	);
};
